<template>
  <div class="page_container" v-loading="loading" @click="showMenu = false">

    <div class="flex_js_wrap">
      <div class="exhibition_left">
        <div class="title">展厅地图</div>
        <ul>
          <li @click.stop="handleClickExhibition(item)" v-for="(item,key) in exhibitionData" :key="key" :class="activeExhibition == item.id ? 'active': ''">
            <p v-text="item.exhibition_hall_name"></p>
            <div>
              <span v-if="key != 0" @click.stop="handleClickEditExhibition(item)"><i class="el-icon-edit"></i></span>
              <span v-if="key != 0" @click.stop="handleClickDelExhibition(item)"><i class="el-icon-delete"></i></span>
            </div>
          </li>
        </ul>
        <div class="add_classify"  @click="handleClickAddExhibition()">
          新增展厅
        </div>
      </div>
      <div class="exhibition_right">
        <div class="add_btn_wrap" v-if="mapInfo && mapInfo.id">
          <el-button  size="small" type="primary" @click="handleClickSave">保存</el-button>
          <el-button  size="small" type="primary" @click="handleClickUpload">上传图片</el-button>
        </div>

        <div class="map_container" >
          <img :src="mapInfo.cover" alt="" @contextmenu.prevent="showContextMenu($event)">
          <div class="point" v-for="(item,index) in mapInfo.position" :key="index" :style="{ left: Number(item.x)-10 + 'px', top: Number(item.y)-10 + 'px' }" @contextmenu.prevent="showPointContextMenu($event,item,index)">
              <div class="point_drop" @click="handlClickPoint(item,index)" >
                <img :src="item.icon" alt="">
                <span class="pulse delay-01"></span>
                <span class="pulse delay-02"></span>
                <span class="pulse delay-03"></span>
<!--                <img src="https://download.hecoos.com/enlightv/2024-41/2c54afefa820aca17125823a17696c18.png" alt="">-->
              </div>
            <div class="project_box" v-if="item.project">
<!--              <img v-if="item.project.cover_image" :src="item.project.cover_image"/>-->
              <div v-if="item.project.title">{{item.project.title}}</div>
            </div>
            <div class="project_box" v-if="item.hall_id && mapInfo.name">
              <div v-text="exhibitionList.find(find =>find.id == item.hall_id) ? exhibitionList.find(find =>find.id == item.hall_id).exhibition_hall_name : ''"></div>
            </div>
          </div>
          <ul v-if="showMenu" class="context-menu" ref="menu">
            <li @click="handleClickAddLandmark">添加坐标</li>
            <!-- 其他菜单项 -->
          </ul>
          <ul v-if="showPointMenu" class="context-menu" ref="pointMenu">
            <li @click="handleClickDelLandmark">删除坐标</li>
            <!-- 其他菜单项 -->
          </ul>
        </div>

      </div>
    </div>

    <associationExhibition :associationExhibitionVisible.sync="associationExhibitionVisible" :disabledIds="disabledIds" :hallId="mapInfo.position[pointIndex].hall_id"  @success="associationExhibitionSuccess"  v-if="associationExhibitionVisible"/>
    <associationExhibitionItem :associationExhibitionItemVisible.sync="associationExhibitionItemVisible" :disabledIds="disabledIds" :hallId="mapInfo.position[pointIndex].project_id"  @success="associationExhibitionItemSuccess"  v-if="associationExhibitionItemVisible"/>


  </div>
</template>
<script>
import {exhibitionHallAdd,exhibitionHallList,exhibitionHallEdit,exhibitionHallDel} from '@/api'
import { uploadImg, getOSSData } from '@/utils/uploadOss'
import associationExhibition from './association_exhibition.vue'
import associationExhibitionItem from './association_exhibition_items.vue'
import {exhibitionHallMap, exhibitionHallMapEdit} from "../../../api";
export default {
  name: 'map_guide_management',
  components: {
    associationExhibition,
    associationExhibitionItem
  },
  data() {
    return {
      keyWord: '',
      loading: false,//加载动画
      showMenu:false,
      menuPosition:null,
      activeExhibition:1,
      exhibitionData:[],
      mapInfo:{},
      associationExhibitionVisible:false,
      associationExhibitionItemVisible:false,
      pointIndex:0,
      disabledIds:[],
      showPointMenu:false,
      exhibitionList:[],
      isEdit:false,
      mapIndexInfo:null
    }
  },
  mounted() {
    this.getExhibitionHallMap()
  },
  methods: {
    // 获取地图首页
    getExhibitionHallMap(){
      this.loading = true
      let postData = {}
      exhibitionHallMap(postData).then(res => {
        if (res.code === 200) {
          let data = res.data
          data.exhibition_hall_name = data.name
          data.position = data.position ? data.position : []
          this.exhibitionData = [data]
          this.mapIndexInfo = data
          this.activeExhibition = (!this.activeExhibition &&  data)? data.id :  this.activeExhibition
          this.mapInfo = (!this.mapInfo.id &&  data) ? data : this.mapInfo
          this.getExhibitionHallList()
        }
        this.loading = false
      })
    },
    // 获取展厅
    getExhibitionHallList(){
      this.loading = true
      let postData = {

      }
      exhibitionHallList(postData).then(res => {
        if (res.code === 200) {
          this.exhibitionData =  this.exhibitionData.concat(res.data)
          this.exhibitionList =  res.data
        }
        this.loading = false
      })
    },
    // 新增展厅
    handleClickAddExhibition(){
      this.$prompt('展厅名称', '新增展厅', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal:false,
        inputPattern: /\S/,
        inputErrorMessage: '请输入'
      }).then(({ value }) => {
        let postData = {
          exhibition_hall_name:value,
        }
        exhibitionHallAdd(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '新增成功',
              type: 'success',
              duration: 1500,
              onClose: () => {}
            });
            this.getExhibitionHallMap()
          }
        })

      }).catch(() => {

      });
    },
    // 选择展厅
    handleClickExhibition(item){
      if(this.isEdit == false){
        this.activeExhibition = item.id
        this.mapInfo = JSON.parse(JSON.stringify(item))
        return false
      }
      this.$confirm('直接退出将不会保存本次编辑内容，是否确认退出', '您本次编辑的内容还未保存', {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'error'
      }).then(() => {

        this.isEdit = false
        this.activeExhibition = item.id
        this.mapInfo = JSON.parse(JSON.stringify(item))
      }).catch(() => {
        return false
      })

    },
    // 编辑展厅
    handleClickEditExhibition(item){
      this.$prompt('展厅名称', '编辑展厅', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal:false,
        inputPattern: /\S/,
        inputErrorMessage: '请输入',
        inputValue: item.exhibition_hall_name,
      }).then(({ value }) => {
        let postData = {
          exhibition_hall_name:value,
          id: item.id
        }
        exhibitionHallEdit(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success',
              duration: 1500,
              onClose: () => {}
            });
            this.getExhibitionHallMap()
          }
        })

      }).catch(() => {

      });
    },
    // 删除展厅
    handleClickDelExhibition(item){
      this.$confirm('删除展厅后，所关联的地图导览首页和小程序页面将一并删除，不可恢复！请谨慎操作！', '提示', {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'error'
      }).then(() => {
        let postData = {
          id:item.id
        }
        exhibitionHallDel(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
              }
            });
            let position = []
            this.mapIndexInfo.position.forEach((list)=>{
              if(list.hall_id != item.id){
                position.push(list)
              }
            })

            let postData = {
              id: this.mapIndexInfo.id,
              cover: this.mapIndexInfo.cover,
              position: position,
            }
            exhibitionHallMapEdit(postData).then(res => {
              if (res.code === 200) {
                this.getExhibitionHallMap()
              }
            })

          }
        })
      }).catch(() => {
        return false
      })
    },
    // 上传图片
    handleClickUpload(){
      let that = this
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('multiple', 'multiple')
      input.setAttribute('accept', '')
      input.click()
      input.onchange = function () {
        const files = this.files[0]
        uploadImg(files).then(res => {
          that.$set(that.mapInfo,'cover',res.file_path)
          that.$set(that.mapInfo,'position',[])
          that.loading = false
          that.$message.success('上传成功')
          that.isEdit = true
        }).catch(() => {
          that.loading = false
        })
      }

    },
    // 保存
    handleClickSave(){
      let data = JSON.parse(JSON.stringify(this.mapInfo.position))
      let flag = false
      data.forEach((item)=>{
        if(!item.hall_id && !item.project_id){
          this.$message.error('请点击坐标点关联展厅或展项')
          flag = true
        }
      })
      if(flag){
        return false
      }
      this.mapInfo.position.forEach((item)=>{
        // delete  item.project
      })
      if(this.mapInfo.name){
        let postData = {
          exhibition_hall_name:this.mapInfo.exhibition_hall_name,
          id: this.mapInfo.id,
          cover: this.mapInfo.cover,
          position: this.mapInfo.position,
        }
        exhibitionHallMapEdit(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
              }
            });
            this.getExhibitionHallMap()
          }
        })
      }else{
        let postData = {
          exhibition_hall_name:this.mapInfo.exhibition_hall_name,
          id: this.mapInfo.id,
          cover: this.mapInfo.cover,
          position: this.mapInfo.position,
        }
        exhibitionHallEdit(postData).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
              }
            });
            this.getExhibitionHallMap()
          }
        })
      }
      this.isEdit = false

    },
    // 点击右键
    showContextMenu(event){
      this.showMenu = true
      this.menuPosition = { x: event.offsetX, y: event.offsetY };
      this.$nextTick(() => {
        this.$refs.menu.style.left = `${event.offsetX}px`;
        this.$refs.menu.style.top = `${event.offsetY}px`;
      });
      this.showPointMenu = false
    },
    // 添加坐标
    handleClickAddLandmark(){
      let data = {
        x:this.menuPosition.x,
        y:this.menuPosition.y,
        icon:'https://download.hecoos.com/enlightv/2024-42/18c834b5efa7c73cbe36310c018cde18.png',
        // icon:'https://download.hecoos.com/enlightv/2024-41/2c54afefa820aca17125823a17696c18.png'

      }
      this.mapInfo.position.push(data)
      this.isEdit = true
    },
    // 点击坐标
    handlClickPoint(item,index){
      this.pointIndex = index
      this.disabledIds = []
      if(this.mapInfo.name){
        this.associationExhibitionVisible = true
        this.mapInfo.position.forEach((list,key)=>{
          if(key != index){
            this.disabledIds.push(list.hall_id)
          }
        })
      }else{
        this.associationExhibitionItemVisible = true
        this.mapInfo.position.forEach((list,key)=>{
          if(key != index){
            this.disabledIds.push(list.project_id)
          }
        })
      }
      this.isEdit = true
    },
    // 选择展厅回调
    associationExhibitionSuccess(data){
      this.$set(this.mapInfo.position[this.pointIndex],'hall_id',data.id)
    },
    // 选择展项回调
    associationExhibitionItemSuccess(data){
      this.$set(this.mapInfo.position[this.pointIndex],'project_id',data.id)
      console.log(data);
      this.$set(this.mapInfo.position[this.pointIndex],'project',data)

    },

    showPointContextMenu(event,item,index){

      this.showPointMenu = true
      this.menuPosition = { x: item.x, y: item.y };
      this.$nextTick(() => {
        this.$refs.pointMenu.style.left = `${item.x}px`;
        this.$refs.pointMenu.style.top = `${item.y}px`;
      });
      this.pointIndex = index
    },
    handleClickDelLandmark(){
      this.mapInfo.position.splice(this.pointIndex,1)
      this.showPointMenu = false
    },

  },
}
</script>
<style lang="scss" scoped>
.flex_js_wrap{
  align-items: initial;
}
.add_btn_wrap {
  padding: 0 0 12px 0;
  text-align: right;
}
.page_container{
  padding: 0;
}
.exhibition_left{
  width: 220px;
  min-width: 220px;
  height: calc(100vh - 140px);
  border-right: 1px solid #ebeef5;
  box-sizing: border-box;
  .title{
    line-height: 56px;
    height: 56px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
  }
  ul{
    width: 100%;
    height: calc(100% - 106px);
    overflow: auto;
    padding: 8px;
    box-sizing: border-box;
    li{
      width: 100%;
      margin-bottom: 8px;
      padding: 0 40px 0 8px;
      box-sizing: border-box;
      border-radius: 4px;
      background: #fff;
      line-height: 30px;
      height: 30px;
      position: relative;
      cursor: pointer;
      &.active{
        background: rgba(25, 144, 255, 0.16);
      }
      &:hover{
        background: rgba(0, 0, 0, 0.04);
        div{
          display: flex;
        }
      }
      p{

      }
      div{
        position: absolute;
        right: 8px;
        width: 32px;
        top: 0;
        justify-content: space-between;
        display: none;
        span{
          i{
            font-size: 14px;
            &:hover{
              color: #1990ff;
            }
          }
        }
      }
    }
  }
  .add_classify{
    width: calc(100% - 24px);
    height: 32px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);
    text-align: center;
    line-height: 32px;
    border: 1px solid #e8e8e8;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    cursor: pointer;
    margin: 0 auto;
  }

}
.exhibition_right{
  padding:16px  16px 0 0;
  width: calc(100% - 220px);
  height: calc(100vh - 150px);
  box-sizing: border-box;
  overflow: auto;
.map_container{
  width: 375px;
  margin: 16px auto;
  position: relative;
  img{
    width: 100%;
    display: block;
  }
  .context-menu {
    position: absolute;
    z-index: 1000;
    list-style: none;
    padding: 8px 0;
    margin: 0;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }

  .context-menu li {
    padding: 8px 20px;
    cursor: pointer;
  }

  .context-menu li:hover {
    background-color: #f0f0f0;
  }
  .point{
    position: absolute;
    width: 20px;
    .point_drop{
      cursor: pointer;
      img{
        display: block;
        width: 100%;
        border-radius: 50%;
        box-shadow: 0px 5px 5px rgba(0,0,0,.3);
        //animation: glow 1s infinite alternate; /* 动画效果 */
      }
      .pulse{
        position: absolute;
        border-color: #2a82e4;
        top: -20px;
        left: -20px;
        height: 60px;
        width: 60px;

        box-shadow: 0 0 12px #2a82e4, 0 0 20px #2a82e4 inset;
        border-radius: 50%;
        opacity: .12;
        filter: alpha(opacity=0);
        animation: warn 2s ease-out both;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        -o-animation-iteration-count: infinite;
        animation-iteration-count: infinite;

        &.delay-01{
          -webkit-animation-delay: 1.2s;
          -moz-animation-delay: 1.2s;
          -o-animation-delay: 1.2s;
          animation-delay: 1.2s;
        }
        &.delay-02{
          -webkit-animation-delay: 1.6s;
          -moz-animation-delay: 1.6s;
          -o-animation-delay: 1.6s;
          animation-delay: 1.6s;
        }
        &.delay-03{
          -webkit-animation-delay: 2s;
          -moz-animation-delay: 2s;
          -o-animation-delay: 2s;
          animation-delay: 2s;
        }
      }
    }
    .project_box{
      display: flex;
      align-items: center;
      position: absolute;
      left: 25px;
      top: -1px;
    }
    .project_box img{
      width: 22px;
      height: 22px;
      min-width: 22px;
      min-height: 22px;
      display: block;
      margin-right: 5px;
    }
    .project_box div{
      font-size: 12px;
      line-height: 22px;
      flex: 1;
      width: max-content;
      background: rgba(0,0,0,0.6);
      padding: 0px 3px;
      border-radius: 3px;
      color: #fff;
      font-weight: bold;
      letter-spacing: -1px;
    }
  }

}
}
@keyframes glow {
  0% {
    transform: scale(1); /* 初始状态 */
    box-shadow: 0px 5px 5px rgba(0,0,0,.3);
  }
  100% {
    transform: scale(1.1); /* 扩大圆形 */
    box-shadow: 0px 5px 15px rgba(0,0,0,.6);
  }
}

@keyframes warn {
  0% {
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -o-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
    opacity: 0;
  }
}



</style>
